module.exports = __webpack_public_path__ + "img/5.49f62abb.png";